import * as React from 'react';

// #region Component Props 

interface IProps {
    children    : any;
    classes?    : string;
}

// #endregion

const DialogHeader : React.SFC<IProps> = (props) => {

    const { children, classes } = props;

    return <div className={"dialog-header-content " + classes }>
            { children }
        </div>;  
};

DialogHeader.defaultProps = {
    classes: ''
};

export { DialogHeader };
